<template>
    <div>
        <div class="wrap-filter display-flex display-flex-space-between">
            <FilterElectronicLectures class="flex-left" @handleSeach="handleSeach" :type="paramQueryData.type" />
            <div @click="handleAddElectronicLecture"
                class="btn-add-electronic-lectures wrap-right display-flex justify-content-end flex-right">
                <a href="javascript:;"
                    class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add">
                    <img class="icon-plus" src="@/assets/img/plus.png" />
                    <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                    Thêm kế hoạch bài dạy
                </a>
            </div>
        </div>
        <ModalCreateUpdateElectronicLectutes @handleDone="handleDone" :lessonId="lessonIdCurrent"
            :type="paramQueryData.type" @closeModal="closeModalCreateUpdate"
            v-if="isOpenModalCreateUpdateElectronicLectures" />


        <ModalDeleteLesson @handleDeleteDone="handleDeleteDone" :lessonId="lessonIdCurrent" :type="paramQueryData.type"
            v-if="isOpenModalDeleteLesson" @closeModal="closeModalDelete" :objectName="objectName" />

        <div class="row" v-if="listDataLessonClassSchool.length > 0">
            <div class="col-md-4" v-for="(item, index) of listDataLessonClassSchool" :key="index">
                <ItemElectronicLecture @handleDeleteItem="handleDeleteItem" @handleEditItem="handleEditItem"
                    @handleOpenModalAssignLesson="handleOpenModalAssignLesson" :type="paramQueryData.type" :item="item"
                    :typeElectronicLecture="ElectronicLectureWarehouse" />
            </div>

        </div>

        <div class="row" v-else>
            <div class="col-md-12 empty-data">Kho kế hoạch bài dạy không có dữ liệu</div>
        </div>

        <div class="row pagination container m-0">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>

        <ModalAssignLesson v-if="isOpenModalAssignLesson" :type="paramQueryData.type" :item="itemAssignSelected"
            @handleAssignSuccess="handleCloseDropdown" @closeModal="handleCloseDropdown" />
    </div>
</template>
<script>
import ModalCreateUpdateElectronicLectutes from './ModalCreateUpdateElectronicLectutes'
import FilterElectronicLectures from './FilterElectronicLectures'
import ItemElectronicLecture from './ItemElectronicLecture'
import { listLessonClassSchool } from './../../_api/LessonClassSchoolServices'
import ModalDeleteLesson from './ModalDeleteLesson'
import { PLANING_LESSON_WAREHOUSE, ELECTRONIC_LECTURE_WAREHOUSE } from './../../constants/constants_enum'
import ModalAssignLesson from './ModalAssignLesson'
export default {
    components: {
        ModalCreateUpdateElectronicLectutes,
        FilterElectronicLectures,
        ItemElectronicLecture,
        ModalDeleteLesson,
        ModalAssignLesson
    },
    data() {
        return {
            PLANING_LESSON_WAREHOUSE, ELECTRONIC_LECTURE_WAREHOUSE,
            ElectronicLectureWarehouse: 2,
            isOpenModalCreateUpdateElectronicLectures: false,
            isOpenModalDeleteLesson: false,
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                type: PLANING_LESSON_WAREHOUSE,
                pageSize: 6,
                subjectId: 0,
                classId: 0,
                statusId: 0
            },
            lessonIdCurrent: 0,
            totalRecords: 0,
            listDataLessonClassSchool: [],
            itemAssignSelected: null,
            isOpenModalAssignLesson: false

        }
    },
    watch: {
        'paramQueryData.pageIndex': 'getListLessonClassSchool',
    },
    mounted() {
        this.getListLessonClassSchool()
    },
    methods: {
        handleCloseDropdown() {
            this.itemAssignSelected = null
            this.isOpenModalAssignLesson = false
        },
        handleOpenModalAssignLesson(item) {
            console.log(item)
            this.itemAssignSelected = item
            this.isOpenModalAssignLesson = true
        },
        handleDeleteDone() {
            this.getListLessonClassSchool()
            this.closeModalDelete()
        },
        handleDeleteItem(item) {
            this.objectName = item.name
            this.lessonIdCurrent = item.id
            this.isOpenModalDeleteLesson = true
        },
        closeModalDelete() {
            this.isOpenModalDeleteLesson = false
        },
        handleEditItem(item) {
            this.lessonIdCurrent = item.id
            this.isOpenModalCreateUpdateElectronicLectures = true
        },
        handleSeach(query) {
            this.paramQueryData.keyword = query.keyword
            this.paramQueryData.subjectId = query.subjectId
            this.paramQueryData.classId = query.classId
            this.paramQueryData.statusId = query.statusId
            this.getListLessonClassSchool()
        },
        handleDone() {
            this.getListLessonClassSchool()
        },
        handleAddElectronicLecture() {
            this.lessonIdCurrent = 0
            this.isOpenModalCreateUpdateElectronicLectures = true
        },
        closeModalCreateUpdate() {
            this.isOpenModalCreateUpdateElectronicLectures = false
        },
        getListLessonClassSchool() {
            let self = this
            listLessonClassSchool(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataLessonClassSchool = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.wrap-filter {
    margin-top: 20px;
}

.pagination {
    margin-bottom: 20px;
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.display-flex-space-between {
    justify-content: space-between;
}

.empty-data {
    margin-top: 15px;
    text-align: center;
}

.flex-left {
    flex: 2;
}

.flex-right {
    flex: 1;
}
</style>